// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__whU1s","fraction":"styles_fraction__kCvsw","circle":"styles_circle__2SiTi"};